import Services from 'fetch-decorator';
import fetch from '../libs/request';

const modules = {
  auth: require('./auth'),
  order: require('./order'),
  parking: require('./parking'),
  payment: require('./payment')
};

Services.globalFetch(fetch);
Services.combine(modules);

export default Services;
